var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BNavbar',{class:{
        'nav wealthime-navbar' : _vm.$isWealthTime,
        'novia-navbar' : !_vm.$isWealthTime,
        'bg-black' : _vm.isWhitelabeled
    },attrs:{"toggleable":"lg"}},[_c('BContainer',[_c('BRow',[(_vm.displayNavigationItems)?_c('NavBarCollapse',{class:{'bg-black' : _vm.isWhitelabeled},attrs:{"id":_vm.collapseId},on:{"closeNavbarClicked":_vm.closeNavbarClicked}},[_vm._t("default")],2):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }